/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */

import React, {useState,useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {DFPAPIEndpointGalley } from "../../../utils/axios";
import '../../../assets/styles//styles.scss';
import '../../../assets/styles/modal.scss';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../assets/styles/styles.scss';
import minus from '../../../images/icons/minusgaly.png';
import plus from '../../../images/icons/plus.png';
import usePermissions from "../../../utils/userPermissions";
import useAccountDomain from '../../../utils/useAccountDomain';
import galley1akasa from '../../../assets/images/galley1akasa.png';
import galley2akasa from '../../../assets/images/galley2akasa.png';
import galley3akasa from '../../../assets/images/galley3akasa.png';
import { galleyComponentData5,galleyComponentData6,galleyComponentData7} from "../../../utils/configs";

import { GalleyLoadingModal } from './galleyLoadingModal';
import CustomSelect from "../../../common/CustomSelect";

const EditFormFields = [
  {label: 'ID', attribute: 'trolleyNo', type: 'text', disabled: false, },
  {key: 1, label: 'Trolley Items', attribute: 'trolleyItem', name: 'trolleyItem', type: 'selectSearch'
        , defaultValue: ''
        , value: ''
        , className: 'select-search-cls'
        , options: []
        , multiple: true
        , search: true
        , autoComplete: 'on'
        , autoFocus: false
        , disabled: false, placeholder: 'Items'
    }
];
export const  StandardGalleyLoading=() =>{
  const { ready } = useTranslation();
  const [toggleState, setToggleState] = useState(null);
  const [galleyIndex, setGalleyIndex] = useState(null);
  const [searchKey] = useState('');
  const [initTab,setInitTab]=useState(null);
   const [resolvedCartOptions, setResolvedCartOptions] = useState(null);
    const [cartsLimitMessage,setCartsLimitMessage] = useState(null);
  const [airCraftLoadingSel,setAircraftLoadingSel]=useState({key:'',galley:'',businessclassName:false,economy:false,premEconomy:false})
  const [ selectedGalley, setSelectedGalley ] = useState({})
  const [galleyDetails, setGalleyDetails] = useState([]);
  const [aircraftOptions, setAircraftOptions] = useState({});
  const [galleyArr, setGalleyArr] = useState([]);
  const [galleyCarts, setGalleyCarts] = useState([]);
  const [galleyCartsDet, setGalleyCartsDet] = useState([]);
  const [cartsStatus,setCartsStatus]=useState({fullCart:0,halfCart:0,smu:0,stowage:0});
    const [cartsCheck,setCartsCheck]=useState({fullCart:0,halfCart:0,smu:0,stowage:0});
  const [cartsGalleyLoading, setCartsGalleyLoading] = useState([]);
  const [galleyItems,setGalleyItems]=useState([]);
  const [galleyLoadingMessage,setGalleyLoadinMessage]=useState({});
  const [saveGalley,setSaveGalley]=useState(false);
  const [saveAlert,setSaveAlert]=useState({action:false,index:null,cancel:false});
  const [trolleyItems,setTrolleyItems]=useState([]);
  const [editGalley,setEditgalley]=useState({});
  const [cartsCon,setCartsCon]=useState([]);
  const [showAddTrolley,setShowAddTrolley]=useState({trolleyNo:""});
  const [boxes, setBoxes] = useState([]);
  const [cartsMax,setCartsMax]=useState([]);
  const [,setTrolleyCheck]=useState({});
  const [imageGalley,setImageGalley]=useState(null);
  const [galleyBoxes, setGalleyBoxes] = useState([]);
  const [titleEdit, setTitleEdit] = useState('Update Galley Details');
  const [displayItems, setDisplayItems] = useState([]);
  const [boxId, setBoxId] = useState(null);

  const [aircraftSwitchToken, setAircraftSwitchToken] = useState(0);
  const domainNGo = useAccountDomain();

  const { hasPermission: createGalleyDesign } = usePermissions('create', "configuration.lcc.galley-design");
  const { hasPermission: editGalleyDesign } = usePermissions('edit', "configuration.lcc.galley-design");
  const { hasPermission: deleteGalleyDesign } = usePermissions('delete', "configuration.lcc.galley-design");
  const { hasPermission: viewDetailsGalleyDesign } = usePermissions('view', "configuration.lcc.galley-design");

  const getGalleyLists=(gl)=>{
    let galleyNames=[]
      if(gl.length){
      galleyNames = gl.reduce(
      (acc, item,index) =>[
      ...acc,
      { key: index + 1, label: item.name, value: item.name },

      ],
      [{ key: 0, label: "Select Galley", value: "" }]
      );
      setAircraftOptions((prev)=>{return {...prev,galleyNames}});
      }
  }
   function showToast (){
        toast.dismiss();

        if (galleyLoadingMessage && galleyLoadingMessage.success) {
          toast.success(galleyLoadingMessage.success, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 3800,
            style: {
              backgroundColor: '#4cae4c',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } else if (galleyLoadingMessage && galleyLoadingMessage.error) {
          toast.error(galleyLoadingMessage.error, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
            pauseOnHover: true,
            draggable: false,
            autoClose: 3800,
            style: {
              backgroundColor: '#d9534f',
              color: '#fff',
              borderRadius: '8px',
              fontSize: '1rem',
              width:'30rem'
            }
          });
        } else {

        }
      };

      async function getAircraftVaraints (){
        try {
          const initialRes = await fetchAirtcraftsType(1,1);
          if (initialRes?.count && Array.isArray(initialRes.items) && initialRes.items.length) {
            const fullRes = await fetchAirtcraftsType(1, initialRes.count);

            setGalleyDetails(fullRes.items);

          }

        } catch (error) {
          console.error("Failed to fetch aircaft:", error);
        }
    }
  useEffect(() => {
    getAircraftVaraints();
    fetchGalleyCatergories();
  }, [])

useEffect(() => {
 if(galleyLoadingMessage && (galleyLoadingMessage.error||galleyLoadingMessage.success)){
  showToast();
  setTimeout(()=>{
    setGalleyLoadinMessage({});
  },5000)
 }
}, [galleyLoadingMessage])

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    const objName=galleyBoxes.find(gb=>{if(gb.id===boxId){
      return gb
    }})
  if(objName&&objName?.name){
    if(boxes.find(bx=>bx.boxId===boxId)){
    const bxObj=  boxes.find(bx=>bx.boxId===boxId)
      bxObj['code']=objName.name
    }
  }
  }, [galleyBoxes,boxes])

  useEffect(() => {
    if(saveAlert.index&&!saveAlert.cancel){
      setToggleState(saveAlert.index);
      setGalleyIndex(saveAlert.index)
    }
  }, [saveAlert])

  useEffect(() => {
    if(boxes.length &&  imageGalley && imageGalley.length){
     const imageName= boxes.map(bx=> bx.imageGalley)
     if(imageName[0]!==imageGalley){
      setBoxes([])
     }
    }
  }, [boxes,galleyIndex,imageGalley])

  useEffect(() => {
    if(cartsCon&&(galleyIndex||initTab)){
       const cartsPr=cartsCon?.find(fx=>{
      if (galleyIndex === null) {
        return fx.index === initTab;
      } else {
        return fx.index === galleyIndex;
      }
    })
    setCartsMax(cartsPr)
    }

  }, [galleyIndex,initTab,boxes,trolleyItems])

  useEffect(() => {
    if(boxes&&boxes.length){
      const updatedB = galleyBoxes.map(bItem => {
        const matchingA = boxes.find(aItem => aItem.boxId === bItem.id);

        if (matchingA && matchingA.code === "" && bItem.name !== "") {
          return { ...bItem, name: "" };
        }

        return bItem;
      });
     setGalleyBoxes(updatedB);
    }
    else {
      const updatedB = galleyBoxes.map(bItem => ({ ...bItem, name: "" }));
      setGalleyBoxes(updatedB);
    }
  }, [boxes,galleyIndex,airCraftLoadingSel])

useEffect(() => {
  if(boxes&&boxes.length){
    for (const kItem of galleyBoxes) {
    const matchingLItem = boxes.find(lItem => lItem.code === kItem.name);
    if (!matchingLItem) {
    kItem.name = "";
    }
    }
  }
}, [boxes,galleyBoxes])

const verifyCartsLimit=()=>{
  let cartLenSmu=0
  let cartLenStowage=0
  let cartLenHalf=0
  let cartLenFull=0

  if(boxes && (galleyIndex||initTab)){
    boxes.forEach(bx=>{
      const {id,cartQuantityAllots}=bx;
      if(id==='smu'){
       cartLenSmu+=bx.cartQuantityAllots.length
    }
    if(id==='stowage'){
      cartLenStowage+=bx.cartQuantityAllots.length
   }
    cartQuantityAllots.forEach(caRt=>{
      if (caRt.cartType === 'fullCart') {
        cartLenFull++;
      } else if (caRt.cartType === 'halfCart') {
        cartLenHalf++;
      }
    })
  })
}
if(boxes.length===0){
  setCartsCheck((_)=>{
    const obj={..._};
    for (const key in obj) {
      obj[key] = 0;
    }
    return obj;
  })

}
setCartsCheck((_)=>{return{..._,smu:cartLenSmu,fullCart:cartLenFull,halfCart:cartLenHalf,stowage:cartLenStowage}})
}


  useEffect(() => {
    verifyCartsLimit()
  }, [boxes,galleyIndex,trolleyItems,editGalley])


  useEffect(() => {
    if(galleyDetails){

      const actModel= galleyDetails.reduce(
      (acc, item, index) => [
      ...acc,
      { key: index + 1, label: `${item.key.replace(/-+/g, '-')}`, value:item.key },
      ],
      [{ key: 0, label: "Select Aircraft Variant", value: "" }]
      );
      if(actModel.length ){
      setAircraftOptions({key:actModel});

      }
    }
  }, [galleyDetails])


  useEffect(() => {
    const cartObj=cartsGalleyLoading.find(f=>f.index===galleyIndex||initTab)
    if(cartsGalleyLoading && galleyCartsDet &&cartObj){
      let configuredCarts=[];

   const currentIndex = galleyIndex || initTab;
   const scopedBoxes = boxes.filter(b => b.index === currentIndex);
   const k=  scopedBoxes.map(m=>m.cartQuantityAllots || [])
   let fullCartCount = 0;
   let halfCartCount = 0;

   for (let i = 0; i < k.length; i++) {
     for (let j = 0; j < k[i].length; j++) {
       const cartType = k[i][j].cartType;
       if (cartType === 'fullCart') {
         fullCartCount++;
       } else if (cartType === 'halfCart') {
         halfCartCount++;
       }
     }
   }

       configuredCarts = galleyCartsDet.map(a => ({
        cart: a.name,
        cartQuant: (a.name === "Full Cart") ? fullCartCount : (a.name === "Half Cart") ? halfCartCount : a.cartConfigCount.typesConfiguredQty
      })).reduce((acc, item) => {
        const existingItem = acc.find(obj => obj.cart === item.cart);
        if (existingItem && existingItem.cart!=='Full Cart' && existingItem.cart!=='Half Cart') {
          existingItem.cartQuant += item.cartQuant;
        } else {
          acc.push({ cart: item.cart, cartQuant: item.cartQuant });
        }
        return acc;
      }, []);


      galleyBoxes.forEach((obj1) => {
        const bName = galleyCartsDet.find((obj2) => obj2.boxId === obj1.id);

        if (bName && bName.code) {
          obj1.name = bName.code;
        }
      });
      const cartsFilled = configuredCarts.reduce((obj, item) => {
        let key = item.cart.replace(/\s+/g, '');
        key = key.toLowerCase()
        if (key === 'fullcart') key = 'fullCart';
        if (key === 'halfcart') key = 'halfCart';
        if (key === 'smu') key = 'smu';
        if (key === 'misc.stowage') key = 'stowage';
        obj[key] = item.cartQuant;
        return obj;
      }, {index:(galleyIndex||initTab)});

    setCartsStatus(cartsFilled)
    getCartDetails();
    }
    else{
    setCartsStatus({fullCart:0,halfCart:0,smu:0,stowage:0})
    }

}, [cartsGalleyLoading,galleyCartsDet,galleyArr,saveGalley,boxes])


  const setTabColor=()=>{
    galleyArr.forEach((el) => {
      if((initTab===galleyIndex&&(el.name===initTab||el.name===galleyIndex))||(!galleyIndex&&(el.name===initTab))||(initTab!==galleyIndex&&(el.name===galleyIndex)))
      {el.saved=true}
    });
    getGalleyTabs();
    getCartDetails();
  }
  const onClickBox=(e,id)=>{
  if(!e.target.alt && e.target.tagName !== 'INPUT'){
if(boxes.find(bx=>bx?.boxId===id)===undefined){
    setShowAddTrolley({trolleyNo:id});
      const galleyObj=boxes.find(b=>b.boxId===id);
      if(galleyObj){
      setEditgalley(galleyObj)
      }
      let editAddFieldsDep=[];
     galleyItems&& galleyItems.map( (fieldValue, index) => {
      editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
      return fieldValue;
      });
      setTrolleyItems(editAddFieldsDep);

      EditFormFields.map( editRow => {

      if (editRow.attribute === 'trolleyItem' ) {
      editRow.options = trolleyItems;
      }
      return editRow;
      });
}
  }
  }

  const convert=(arr) =>{
    const boxIdMap = {};
    return arr.reduce((newArr, item) => {
      const data = boxIdMap[item.boxId];
      if (data) {
        data.cartQuantityAllots = data.cartQuantityAllots.concat(item.cartQuantityAllots);
      } else {
        const copy = { ...item };
        boxIdMap[item.boxId] = copy;
        newArr.push(copy);
      }
       return newArr
    }, []);
  }


  const fetchGalleyCatergories=async()=>{
    try {
      const resp = await DFPAPIEndpointGalley.get(`galley/items/category`);
        if(resp.success){
        setGalleyItems(resp.items)
        }
        }
        catch (error) {

        }

  }
    const filterData = {
      action: 4,
      collection: '',
      filterOperation: 'or',
      filters: [],
      limit: 50,
      page: 1,
      searchParam: ''
    };
    const fetchAirtcraftsType = async (page = 1, perPage = 50) => {
      filterData.page = page;
      filterData.limit = perPage;
      filterData.filters =  [];
      filterData.searchParam = searchKey;
      try {
         const res = await DFPAPIEndpointGalley.post('galley/aircraftTypes/process', filterData);
      if(res){
        // setGalleyDetails(res.items);
        return res;
      }
      } catch (error) {

      }

    }
        const onCloseAddGalley=()=>{
          setShowAddTrolley({trolleyNo:""});
          setDisplayItems([]);
          setTitleEdit("Update Galley Details")
          setEditgalley({});
          setCartsLimitMessage(null);
          setResolvedCartOptions(null);
        }

        const getCartType=(cart)=>{
          let re=''
          switch (cart) {
            case 'fullCart':
            re= 'Full Cart'
            break;
            case 'halfCart':
            re= 'Half Cart'
            break;
            case 'smu':
            re= 'SMU'
            break;
            case 'stowage':
            re= 'Misc. Stowage'
            break;
            default:
            break;
          }
          return re
        }

const getItemsCart=(val)=>{
 const resp= val?.map((item,index) => {
    return {
      typeId:index+1,
      name: galleyItems?.find(i => i.name === item?.name)?.name
    }
    })
    return resp;
}


const getBoxName=()=>{
  // eslint-disable-next-line array-callback-return
  const objName=galleyBoxes.find(gb=>{if(gb.id===showAddTrolley.trolleyNo){
    return gb
  }})
 return objName.name
}
      const getCartsId=(option)=>{
      const {cartOptions,cartType}=option
      let cId=null;
      if(cartOptions==='0'){
      cId=galleyCartsDet.find(ct=>ct?.id===cartType)?._id;
      }
      if(cartOptions==='1'){
      cId=galleyCartsDet.find(ct=>ct?.id===cartType)?._id;

      }
      if(cartOptions==='2' &&cartType==='fullCart'){
      cId=galleyCartsDet.find(ct=>ct?.id==='full')?._id;
      }
      if(cartOptions==='2' &&cartType==='halfCart'){
      cId=galleyCartsDet.find(ct=>ct?.id==='half')?._id;

      }
      return cId;
      }

      const getCartQunatityAllots=(updated)=>{
        return [
          {
              code: generateRandomVariable()||'897GH',
              cartType: updated.cartType?updated.cartType:updated.cartOptions==='1'?'smu':'stowage',
              typesOfItems:getItemsCart(updated.cartItems),
              ...(updated.crewPositionByHalf
                ? { crewPositionByHalf: updated.crewPositionByHalf }
                : { crewPositions: updated.crewPositions || [] })
          }
      ]
      }

      const onSubmitGalleyBoxes=(updated)=>{
      setTrolleyCheck({cartType:updated.cartType,boxId:showAddTrolley.trolleyNo})
        const{fullCart,halfCart,smu,stowage}=updated
       const res= Object.values(cartsGalleyLoading.reduce((acc, el) => {
          el.fullCart=fullCart;
          el.halfCart=halfCart;
          el.smu=smu;
          el.stowage=stowage;
          el.index=galleyIndex||initTab
          acc[el.index] = el;
          return acc;
        }, {}));
      setCartsGalleyLoading([...res])
      const galleyObj=boxes.find(b=>b.boxId===showAddTrolley.trolleyNo);
      if(updated && !Boolean(galleyObj)&&!Object.keys(editGalley).length){
      setBoxes(( currentValue ) => [ ...currentValue, {
        code: getBoxName(),
        id:(updated.cartOptions==='2'&&updated.cartType==='fullCart')?'full':(updated.cartOptions==='2'&&updated.cartType==='halfCart')?'half':updated.cartOptions==='1'?'smu':'stowage',
        name: (updated.cartOptions==='2'&&updated.cartType==='fullCart')?'Full Cart':(updated.cartOptions==='2'&&updated.cartType==='halfCart')?'Half Cart':updated.cartOptions==='1'?'SMU':'Misc. Stowage',
        _id:getCartsId(updated),
        quantity:getCartQunatityAllots(updated).length,
        boxId: `${showAddTrolley.trolleyNo}`,
        cartQuantityAllots:getCartQunatityAllots(updated),
        index:galleyIndex||initTab,
        imageGalley
    } ])

      setShowAddTrolley({trolleyNo:""});
      }
      if(galleyObj && !Object.keys(editGalley).length){
    const capacityError = getBoxCapacityError(galleyObj, updated.cartType);
    if (capacityError) {
      setGalleyLoadinMessage({ error: capacityError });
      return;
    }
    const arr=  convert([...boxes,{
      code: getBoxName(),
      id:(updated.cartOptions==='2'&&updated.cartType==='fullCart')?'full':(updated.cartOptions==='2'&&updated.cartType==='halfCart')?'half':updated.cartOptions==='1'?'smu':'stowage',
      name: (updated.cartOptions==='2'&&updated.cartType==='fullCart')?'Full Cart':(updated.cartOptions==='2'&&updated.cartType==='halfCart')?'Half Cart':updated.cartOptions==='1'?'SMU':'Misc. Stowage',
      quantity:getCartQunatityAllots(updated).length,
      _id:getCartsId(updated),
      boxId: `${showAddTrolley.trolleyNo}`,
      cartQuantityAllots:getCartQunatityAllots(updated),
      index:galleyIndex||initTab,
      imageGalley
  } ])
setBoxes(arr);

     setShowAddTrolley({trolleyNo:""});
      }
      if(Object.keys(editGalley).length&&updated){
        const replaceCart={
          code: updated.code,
          cartType: updated.cartType,
          typesOfItems: getItemsCart(updated.cartItems),
          ...(updated.crewPositionByHalf
            ? { crewPositionByHalf: updated.crewPositionByHalf }
            : { crewPositions: updated.crewPositions || [] })
      }


        function replaceObject(array, searchCode, replacementObj) {
          array.forEach(obj => {
            obj.cartQuantityAllots.forEach((subObj, index) => {
              if (subObj.code === searchCode) {
                obj.cartQuantityAllots[index] = replacementObj;
              }
            });
          });
        }
        replaceObject(boxes, editGalley.code, replaceCart);
        setShowAddTrolley({trolleyNo:""});
        setEditgalley({});
      }
      }



      const showCartDesign=(crt,id,parentBox)=>{
        if(crt.length){
        const cartStat=crt.map((c,index)=>(<>
      <div className="cart-display" title="Edit Cart" onClick={(e) => onClickEditCart(e, id, c.code)}>
  <div className="cart-content-scroll">
    <div className="flexRow" style={{ padding: '0.5rem' }}>
      <u className="cart-type">{getCartType(c.cartType)}</u>
      <div title ="Remove Cart" className="flexRow" style={{ marginLeft: 'auto' }}>
        <img
          className="galley-icons"
          src={minus}
          onClick={(e) => onClickRemoveCart(e, id, c.code)}
          alt="GalleyRemove"
        />
      </div>
    </div>
    {(() => {

      const crewPositionByHalf = c.crewPositionByHalf;
      const crewPositions = (c.crewPositions && c.crewPositions.length)
        ? c.crewPositions
        : (parentBox?.crewPositions || []);
      const crewLabel = crewPositionByHalf
        ? [crewPositionByHalf.leftHalf, crewPositionByHalf.rightHalf].filter(Boolean).join(' / ')
        : crewPositions.join(' / ');
      return crewLabel ? (
        <div className="crew-position-indicator textAlignCenter">
        {crewLabel}
        </div>
      ) : null;
    })()}

    <br />
    {getTrolleyItems(c, id)}
  </div>
</div>

        </>))
        return cartStat
        }

        }
const getTrolleyItems = (tr, id) => {
  if (!tr || !tr.typesOfItems?.length) return null;

  const count = tr.typesOfItems.length;
  const label = count > 1 ? 'items' : 'item';

  return (
    <div className="trolley-items-wrapper">
      <div
        className="list-items"
        style={{ lineHeight: '1.5rem',
          color: '#ffffff',
          display: 'flex',
          fontWeight: 'bold',
          justifyContent: 'center',
          cursor: 'pointer'
        }}
      >
        {`${count} ${label}`}
      </div>
      <div className="trolley-items-popup">
        <ul className="trolley-items-list">
          {tr.typesOfItems.map((item, index) => (
            <li className="box-items" key={item._id || index}>
              {item.name}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
    const getCartsToSave=()=>{
        const idsBoxes = boxes.map(obj => obj._id);
        const objAdd = galleyCartsDet.filter(obj => !idsBoxes.includes(obj._id));
        boxes.push(...objAdd);

        const hasRealCrewData = (box) => {
          const itemHasData = (box.cartQuantityAllots || []).some((item) => {
            if (item.crewPositionByHalf) {
              return Boolean(item.crewPositionByHalf.leftHalf || item.crewPositionByHalf.rightHalf);
            }
            if (item.crewPositions && item.crewPositions.length) {
              return item.crewPositions.some(Boolean);
            }
            return false;
          });
          if (itemHasData) return true;

          if (box.crewPositionByHalf && (box.crewPositionByHalf.leftHalf || box.crewPositionByHalf.rightHalf)) {
            return true;
          }
          if (box.crewPositions && box.crewPositions.some(Boolean)) {
            return true;
          }
          return false;
        };

        const boxesUpdated = boxes.map(item2 => {
          const cartQuantityAllots = normalizeCartItems(item2);
          const isActuallyConfigured = hasRealCrewData(item2);
      
          const crewFields = isActuallyConfigured
            ? aggregateCrewPositions({ ...item2, cartQuantityAllots })
            : {};
          const match = galleyBoxes.find(item1 => item1.id === item2.boxId);
          const { crewPositions, crewPositionByHalf, ...rest } = match
            ? { ...item2, code: match.name, cartQuantityAllots }
            : { ...item2, cartQuantityAllots };
          return { ...rest, ...crewFields };
        });

 
        const idsWithBox = new Set(
          boxesUpdated.filter((c) => c.boxId).map((c) => c.id)
        );
        const finalCarts = boxesUpdated.filter(
          (cart) => cart.boxId || !idsWithBox.has(cart.id)
        );

        return finalCarts;
      }

      const generateRandomVariable=()=> {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        var variable = '';

        for (var i = 0; i < 5; i++) {
          var randomIndex = Math.floor(Math.random() * characters.length);
          variable += characters[randomIndex];
        }

        return variable;
      }

      const getBoxCapacityError = (existingBox, addingCartType) => {
        if (!existingBox) return null;

        if (existingBox.id === 'smu') {
          if ((existingBox.cartQuantityAllots || []).length >= 1) {
            return 'Only one SMU can be added to this position.';
          }
          return null;
        }

        if (existingBox.id === 'full' || existingBox.id === 'half') {
          const items = existingBox.cartQuantityAllots || [];
          const hasFullCart = items.some((i) => i.cartType === 'fullCart');
          const halfCartCount = items.filter((i) => i.cartType === 'halfCart').length;

          if (hasFullCart) {
            return 'This position already has a Full Cart — only one Full Cart is allowed here.';
          }
          if (halfCartCount >= 2) {
            return 'This position already has 2 Half Carts — no more can be added.';
          }
          if (addingCartType === 'fullCart' && halfCartCount > 0) {
            return 'This position already has Half Cart(s) — a Full Cart cannot be added here.';
          }
        }

        return null;
      }

      const aggregateCrewPositions = (box) => {
        const cartQuantityAllots = box.cartQuantityAllots || [];

        if (box.id === 'full') {
          const item = cartQuantityAllots.find((i) => i.crewPositionByHalf) || cartQuantityAllots[0];
          const { leftHalf = '', rightHalf = '' } = item?.crewPositionByHalf || {};
          if (leftHalf || rightHalf) {
            return { crewPositions: [leftHalf, rightHalf], crewPositionByHalf: { leftHalf, rightHalf } };
          }
          const fallback = (box.crewPositions && box.crewPositions.length) ? box.crewPositions : ['', ''];
          return {
            crewPositions: fallback,
            crewPositionByHalf: { leftHalf: fallback[0] || '', rightHalf: fallback[1] || '' },
          };
        }

        const positions = [];
        cartQuantityAllots.forEach((item) => {
          if (item.crewPositions && item.crewPositions.length) {
            positions.push(...item.crewPositions);
          }
          if (item.crewPositionByHalf) {
            const { leftHalf, rightHalf } = item.crewPositionByHalf;
            if (leftHalf) positions.push(leftHalf);
            if (rightHalf) positions.push(rightHalf);
          }
        });
        if (positions.length) return { crewPositions: [positions[0]] };
        return { crewPositions: (box.crewPositions && box.crewPositions.length) ? [box.crewPositions[0]] : [] };
      }

      const normalizeCartItems = (box) => {
        const isFullCartBox = box.id === 'full';
        return (box.cartQuantityAllots || []).map((item) => {
          if (isFullCartBox) {
            return {
              ...item,
              crewPositionByHalf: item.crewPositionByHalf || { leftHalf: '', rightHalf: '' }
            };
          }
          return {
            ...item,
            crewPositions: item.crewPositions || []
          };
        });
      }

      const onSaveGalleyLoading=async()=>{
        const cartsPr=cartsCon.find(fx=>{
          if (galleyIndex === null) {
            return fx.index === initTab;
          } else {
            return fx.index === galleyIndex;
          }
        })
        setCartsMax(cartsPr)
      const {id}=selectedGalley
      let body={}
      if(galleyArr.find((ar=>ar.name===(galleyIndex||initTab)))){
      const gId=galleyArr.find((ar=>ar.name===(galleyIndex||initTab)))._id
      body={
      "aircraftTypeId":id,
      "galleyId": gId,
      "carts": getCartsToSave()
      }
      }
      try {
      const resp = await DFPAPIEndpointGalley.post(`galley/loading/Plan/save`,body);
      if(resp.success){
      setSaveGalley(true);
      setBoxId(null);
      setTabColor();
      getAircraftVaraints();
      setGalleyLoadinMessage({success:resp.message});
      setSaveAlert((prev)=>{return {...prev,action:false,cancel:true}});
      }
      if(!resp.success){
        setGalleyLoadinMessage({error:resp.message.splice(0,8)});

      }
      }
      catch (error) {
        setBoxId(null);
        const errMsg=JSON.parse(error?.message);
        setGalleyLoadinMessage({ error: errMsg?.data?.message });
      }
      setTimeout(() => {
        setSaveGalley(false)
        }, 4000);
      }


  useEffect(() => {
    if(galleyDetails){
        const actModel= galleyDetails.reduce(
        (acc, item, index) => [
        ...acc,
        { key: index + 1, label: `${item.key.replace(/-+/g, '-')}`, value:item.key },
        ],
        [{ key: 0, label: "Select Aircraft Variant", value: "" }]
        );

        if(actModel.length ){
        setAircraftOptions({key:actModel});

        }
    }
  }, [galleyDetails])

  useEffect(() => {
    if(galleyIndex||initTab){
      setBoxId(null);
     setBoxes(galleyCartsDet.filter(item => item.index && item.imageGalley))
     const specGal=galleyDetails.find((g,index)=>g.key===selectedGalley?.key)?.galleys
     setGalleyCarts(specGal);
     let index = galleyArr.find(x => x.name === (galleyIndex || initTab))?.name;
     getGalleyTabs();
     if(index&&index.length>0){
 if (boxes.length) {
       if (index.includes('G1')) {
         setGalleyBoxes(galleyComponentData7);
         setImageGalley(galley3akasa);
       } else if (index.includes('G2')) {
         setGalleyBoxes(galleyComponentData6);
         setImageGalley(galley2akasa);
       } else if (index.includes('G4')) {
         setGalleyBoxes(galleyComponentData5);
         setImageGalley(galley1akasa);
       } else {

       }
     } else {
       if (index.includes('G1')) {
         setGalleyBoxes(galleyComponentData7.map(item => ({ ...item, name: "" })));
         setImageGalley(galley3akasa);
       } else if (index.includes('G2')) {
         setGalleyBoxes(galleyComponentData6.map(item => ({ ...item, name: "" })));
         setImageGalley(galley2akasa);
       } else if (index.includes('G4')) {
         setGalleyBoxes(galleyComponentData5.map(item => ({ ...item, name: "" })));
         setImageGalley(galley1akasa);
       } else {

       }
     }
     }

    }
  }, [galleyIndex,initTab,aircraftSwitchToken])

  useEffect(() => {
        if(galleyDetails&&galleyDetails.length && selectedGalley){
      const specGal=galleyDetails.find((g,index)=>g.key===selectedGalley?.key)?.galleys
      setGalleyCarts(specGal)
    }
  }, [saveGalley,galleyDetails])


  useEffect(() => {

     setBoxes(galleyCartsDet.filter(item => item.index && item.imageGalley))


  }, [galleyIndex,initTab,galleyCartsDet])




  useEffect(() => {
    if (galleyCarts && galleyCarts.length) {
      galleyCarts?.forEach((gc) => {
          if (gc.name === (galleyIndex || initTab)) {
            setGalleyCartsDet(gc.carts);
          }
      });
    }

  }, [galleyCarts,galleyIndex,initTab,saveGalley])

  useEffect(() => {
    if(galleyCartsDet){
      let cartsCount=galleyCartsDet.reduce((acc, cur) => ({ ...acc, [cur.name]: cur.quantity }), {});
    if(Object.keys(cartsCount).length){
    setCartsGalleyLoading([{fullCart:cartsCount['Full Cart'],halfCart:cartsCount['Half Cart'],smu:cartsCount['SMU'],stowage:cartsCount['Misc. Stowage'],index:(galleyIndex||initTab)} ])
    }
    const indices = [...new Set(cartsGalleyLoading.map(item => item.index))];
    indices.forEach(ele => {
      setCartsGalleyLoading(( currentValue ) => [ ...currentValue, cartsGalleyLoading.findLast((element) => element.index === ele) ])
    })
    }
  }, [galleyCartsDet,saveGalley])


  useEffect(() => {
    if(galleyArr&&galleyArr.length){
     const firstTabName = galleyArr[0].name;
     setInitTab(firstTabName)
    galleyArr.forEach((el) => {
      el.saved = false;
    });
   getGalleyTabs();
   const newCartsCon = galleyArr.map((gl) => {
    const userDefinedCarts = gl.galleyCartConfig?.userDefined?.map((ct) => {
      return { ...ct };
    });

    return {...userDefinedCarts, index: gl.name };
  });
  const resArr=[];

  newCartsCon.forEach((item, index) => {
  const modObj = {};
    for(let c in item){
      if (item.hasOwnProperty(c)) {

     if(item[c].hasOwnProperty('full')){

      modObj['fullCart'] = item[c].full;

     }
     else if(item[c].hasOwnProperty('half')){
      modObj['halfCart'] = item[c].half;
     }
     else if(item[c].hasOwnProperty('smu')){
      modObj['smu']=item[c].smu;
     }
    else if(item[c].hasOwnProperty('stowage')){
      modObj['stowage']=item[c].stowage;
    }
    else if(typeof item[c]==='string'){
      modObj['index']=item[c];
    }
      }
    }
    resArr.push(modObj);
  });
  setCartsCon((_)=>{return[..._,...resArr]})
    setGalleyIndex(firstTabName);
    } else {
      setGalleyIndex(initTab);
    }
  }, [galleyArr])

  const isCartLimitReached = (cartType) => {
  if (!cartsMax || !cartsCheck) return false;
  return (cartsCheck[cartType] ?? 0) >= (cartsMax[cartType] ?? 0);
};


useEffect(() => {
  if (!resolvedCartOptions) return;

  const isEditingExistingCart = Boolean(Object.keys(editGalley).length);
  if (isEditingExistingCart) {
    setCartsLimitMessage(null);
    return;
  }

  const reached = isCartLimitReached(resolvedCartOptions);

  if (reached) {
    setCartsLimitMessage(
      `Maximum limit to add ${
        resolvedCartOptions === 'fullCart'
          ? 'full cart'
          : resolvedCartOptions === 'halfCart'
          ? 'half cart'
          : resolvedCartOptions
      } has reached.`
    );
  } else {
    setCartsLimitMessage(null);
  }
}, [resolvedCartOptions, cartsCheck, cartsMax, editGalley]);


  const onAircraftChange=(e,ac=null)=>{
    setAircraftLoadingSel((prev)=>{return {...prev, key: e?.value}});
    setAircraftSwitchToken((t) => t + 1);

  const galleySelected=galleyDetails.find(gl=>gl.key===e?.value) || null

  if(galleySelected && galleySelected?.galleys?.length){
    setSelectedGalley(galleySelected)
    setGalleyArr(galleySelected.galleys);
    getGalleyLists(galleySelected.galleys);
    toggleTab(galleySelected?.galleys[0]?.name);
  }
  else {
    setSelectedGalley(null);
    setGalleyArr([]);
    getGalleyLists([]);
    toggleTab(null);
  }
  }
const onChangeBoxName=(e,id)=>{

  setBoxId(id);
setGalleyBoxes(galleyBoxes.map(g=>{if(g.id===id){
  g.name=e.target.value
}
return g
}))
}

const onClickAddCart=(e,id)=>{
  if(e.target.alt==="GalleyAdd" && createGalleyDesign){
    const existingBox = boxes.find(b=>b.boxId===id);
    if (getBoxCapacityError(existingBox, null)) {
     
      return;
    }
    setShowAddTrolley({trolleyNo:id});
    setEditgalley({})
    let editAddFieldsDep=[];
   galleyItems&& galleyItems.map( (fieldValue, index) => {
    editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
    return fieldValue;
    });
    setTrolleyItems(editAddFieldsDep);

    EditFormFields.map( editRow => {

    if (editRow.attribute === 'trolleyItem' && editGalleyDesign ) {
    editRow.options = trolleyItems;
    }
    return editRow;
    });
  }

}
  const onClickRemoveCart=(e,id,code)=>{

  if(e.target.alt==="GalleyRemove" && deleteGalleyDesign){
  const deleteCart=boxes.find(b=>b.boxId===id).cartQuantityAllots.filter(cr=>cr.code===code)
  if(deleteCart.length){
  boxes.forEach(obj => {
  obj.cartQuantityAllots = obj.cartQuantityAllots.filter(subObj => subObj.code !== deleteCart[0]?.code);
  });
  }
  setBoxes(boxes.filter(obj => obj.cartQuantityAllots.length > 0));
  }
  }

    const onClickEditCart=(e,id,code)=>{
    if(!e.target.alt){
    setShowAddTrolley({trolleyNo:id});
    const parentBox=boxes.find(b=>b.boxId===id);
    const editBoxes=parentBox.cartQuantityAllots.filter(cr=>cr.code===code)
    if(editBoxes.length){
    editBoxes
    .forEach((el) => {
      el.id = id;
      if (!el.crewPositions && !el.crewPositionByHalf) {
        el.crewPositions = parentBox.crewPositions || [];
      }
    });
    setEditgalley(editBoxes[0])
    }
    let editAddFieldsDep=[];
    galleyItems&& galleyItems.map( (fieldValue, index) => {
    editAddFieldsDep.push({ key: fieldValue.customerId, name: fieldValue.name, value: fieldValue.name, label: fieldValue.name })
    return fieldValue;
    });
    setTrolleyItems(editAddFieldsDep);

    EditFormFields.map( editRow => {

    if (editRow.attribute === 'trolleyItem' ) {
    editRow.options = trolleyItems;
    }
    return editRow;
    });
    }
    }

const showGalleyLoading=()=>{

  return(
    <div className="container-fluid dashboard-summary-container">
    {
      <>
        <ToastContainer/>
        <div className='flexRow margBot10 margTop8'>
        <div className='alignItemsCenter'>
        <div className="container-fluid first">
        <div className="row tab-pane">
        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
        {!airCraftLoadingSel?.key?.includes('Select Aircraft')&& galleyArr.length!==0?<><a className="d-block image-block">
        {imageGalley&& viewDetailsGalleyDesign &&<><img className="Images_galley_ak" src={imageGalley}  alt='Galley'/>
        {
        galleyBoxes
        .map((_,index) => {
        return (
          <>
        <div id={_.id} className="ImageArea sm-scrollbar"
        onClick={(e)=>onClickBox(e,_.id)}
        style={{
        width: _.width,
        height: _.height,
        bottom: _.bottom,
        left: _.left,
        overflowY:'auto'
        }}
        key={index}
        >
<div className="flexRow justifyContentSpaceBetween">
<label htmlFor={'boxNames'} style={{ position: 'relative', width: '65%' }}>
  <input
    id={'boxNames'}
    name='carrierCode'
    onChange={(e) => onChangeBoxName(e, _.id)}
    value={_.name}
    style={{ borderRadius: '5px', width: '100%',padding:'0.5rem' }}
    type={'text'}
    placeholder={"Id"}
    className='edit_input_galley'
  />
</label>
{createGalleyDesign?(() => {
  const existingBoxForAdd = boxes.find(b => b.boxId === _.id);
  const atCapacity = Boolean(getBoxCapacityError(existingBoxForAdd, null));
  return (
    <img
      className={`galley_icons_add ${imageGalley?.includes('galley1akasa') ? 'akasaGalleyFull' : 'akasaGalleyHalf'}`}
      src={plus}
      onClick={atCapacity ? undefined : (e) => onClickAddCart(e, _.id)}
      alt='GalleyAdd'
      title={atCapacity ? 'Maximum carts already added to this position' : "Add Cart"}
      style={atCapacity ? { opacity: 0.35, cursor: 'not-allowed', pointerEvents: 'none' } : undefined}
    />
  );
})():<></>}
</div>



        {boxes.map((item,index) => {
        if(item.boxId === _.id&& item.index===(galleyIndex||initTab)){
        return (<>
           <div className='galley_box flexCol' key={index}>
       { showCartDesign(item.cartQuantityAllots,_.id,item)}
        </div>
        </>
        )
        }
        return null;
        }
        )}
        </div></>
        )
        })

        }
        </>
        }
        </a></>:<div style={{width:'270px',top:'35vh',left:'35vh'}} className="image-block">No Galleys Found !</div>}
        </div>
        </div>
       </div>

    </div>

    </div>
    <div>
    </div>

      </>
    }
    {showAddTrolley?.trolleyNo.length>0 && (
        <GalleyLoadingModal
        key={showAddTrolley?.trolleyNo}
        trolleyName={showAddTrolley?.trolleyNo}
        imageGalley={imageGalley}
        onCartOptionsResolved={(value) => setResolvedCartOptions(value)}
        cartsLimitMessage={cartsLimitMessage}
        title={titleEdit}
        airlines={domainNGo}
        galleyCarts={galleyCarts}
        editGalley={editGalley}
        galleyCartsDet={galleyCartsDet}
        tab={galleyIndex||initTab}
        trolleyItems={trolleyItems||[]}
        displayItems={displayItems}
        cartsGalleyLoading={cartsGalleyLoading}
        setGalleyCarts={setGalleyCarts}
        onClose={()=>onCloseAddGalley()}
        onSubmit={onSubmitGalleyBoxes}
        />
      )
   }

  </div>)
}

const getGalleyTabs=()=>{

  const res=galleyArr.map((gl,index)=>{
    return( <>
      <button key={index} style={{width:'180px',marginTop:'0.95rem',marginBottom: '1.2rem'}}
      className={(toggleState||initTab)===gl.name &&!gl.saved? "tabs active-tabs" :(toggleState||initTab)===(gl.name||initTab)&&(gl.saved)? "tabs  active-tabs active-tabs-save":gl.saved?"tabs active-tabs-save":"tabs"}
      onClick={() => toggleTab(gl.name)}
      >
      { gl.name}
      </button>
       </>

    )
}
)
return res

}

const getCartDetails = () => {
  const { fullCart, halfCart, smu, stowage } = cartsStatus;

  if (!galleyCartsDet) return null;

  return (
    <>
      <div className="flexCol" style={{ overflowX: 'auto' }}>
        <div className="flex_container_galley">
          <div className="flexCol">
            <div className="galley-carts">
              <div className="flexCol floatLeft">
                {cartsMax ? (
                  <ul className="ul-class">
                    <span
                      className="justifyContentCenter alignItemsCenter margLeft16"
                      style={{ textDecoration: 'underline' }}
                    >
                      Galley Details
                    </span>
                    <br />
                    <br />

                    {/* Full Cart */}
                    <li className="floatLeft">
                      <span className="tb-tabs">Full Cart</span>
                    </li>
                    <li className="floatRight margLeft10">
                      <span className="round-border-count">{fullCart}</span>
                      <span>&#8725;</span>
                      <span className="round-border">{cartsMax?.fullCart ?? 0}</span>
                    </li>
                    <br />
                    <br />

                    {/* Half Cart */}
                    <li className="floatLeft">
                      <span className="tb-tabs">Half Cart</span>
                    </li>
                    <li className="floatRight margLeft10">
                      <span className="round-border-count">{halfCart}</span>
                      <span>&#8725;</span>
                      <span className="round-border">{cartsMax?.halfCart ?? 0}</span>
                    </li>
                    <br />
                    <br />

                    {/* SMU */}
                    <li className="floatLeft">
                      <span className="tb-tabs">SMU</span>
                    </li>
                    <li className="floatRight margLeft10">
                      <span className="round-border-count">{smu}</span>
                      <span>&#8725;</span>
                      <span className="round-border">{cartsMax?.smu ?? 0}</span>
                    </li>
                    <br />
                    <br />

                    {/* Misc Stowage */}
                    <li className="floatLeft">
                      <span className="tb-tabs">Misc.Stowage</span>
                    </li>
                    <li className="floatRight margLeft10">
                      <span className="round-border-count">{stowage}</span>
                      <span>&#8725;</span>
                      <span className="round-border">{cartsMax?.stowage ?? 0}</span>
                    </li>
                    <br />
                    <br />
                  </ul>
                ) : null}
              </div>
            </div>
          </div>
        </div>

        <button
          style={{ width: '1rem', marginTop: '1rem' }}
          className={
            saveGalley
              ? 'save-button-galley subheading-text-medium-title fontLight button_inrt'
              : 'save-button-galley subheading-text-medium-title fontLight'
          }
          onClick={onSaveGalleyLoading}
        >
          Save
        </button>
      </div>
    </>
  );
};


const getTabContents=()=>{
    return((toggleState||initTab)&&(galleyIndex||initTab) &&(toggleState||initTab )=== (galleyIndex||initTab)?
    <div className={(toggleState||initTab) === (galleyIndex||initTab) ? "content_default  active-content" : "content_default"}>
      <>
      {showGalleyLoading()}
      </>
    </div>:<></>)

}

  const toggleTab = (index) => {
  setToggleState(index);
  setGalleyIndex(index)

  };
  return (
    <div>
    <div className="flexRow" style={{overflowY: 'auto',height:"100vh" }}>
    <div className="bloc-tabs width20Galley column-trolley" >
    <div>
    <label className="req mb-2 margBottom10">
    Aircraft Variant :
    <br />
    <div className="margTop8 width100">
    {Boolean(aircraftOptions) ? (
     <button className='saleType-div margRight30'>
     <CustomSelect
    options={aircraftOptions?.key}
    placeHolder="Select Aircraft Variant"
    width={'13rem'}
    value={aircraftOptions?.key?.filter(option=> option.label === airCraftLoadingSel.key)}
    onChange={onAircraftChange}
    />
     </button>
    ) : (
    <></>
    )}
    </div>
    </label>
    </div>




    <div className="flexRow width100 margBot10">
                <div className="alignItemsCenter">

                  <div className="bloc-tabs-trolley">
                  {!airCraftLoadingSel?.key?.includes('Select Aircraft')&&galleyArr&&galleyArr.length?getGalleyTabs():<></>}
                  </div>

                    {!airCraftLoadingSel?.key?.includes('Select Aircraft')&&galleyCartsDet&&galleyCartsDet.length &&galleyArr.length ?(getCartDetails()):null}
                </div>
              </div>
    </div>
    <div style={{display:'flex',width:'80%',overflowY:'scroll'}}>
    {!airCraftLoadingSel?.key?.includes('Select Aircraft')&& getTabContents()}
    </div>
    </div>
    {
    !ready &&<div className='overlay_hide sub'></div>
    }
    </div>
  );
}